import { createReducer } from "@reduxjs/toolkit";
import { Comune, Comuni } from "models/comune.model";
import { Provincia } from "models/provincia.model";
import {
	commonGetComuni,
	commonGetProvince,
	commonInitApp,
	hideLoader,
	showLoader,
} from "./actions";

export interface CommonReducerType {
	generalLoader: number;
	loader: { [key: string]: number };
	isInit: boolean;
	province: Provincia[] | undefined;
	comuni: Comuni | undefined;
}

const initialState: CommonReducerType = {
	generalLoader: 0,
	loader: {},
	isInit: false,
	province: undefined,
	comuni: undefined,
};

const whitelistLoader: string[] = [];

export const commonReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(showLoader, (state, action) => {
			if (!action.payload) {
				state.generalLoader = state.generalLoader + 1;
			} else {
				state.loader[action.payload] = (state.loader[action.payload] || 0) + 1;
			}
		})
		.addCase(hideLoader, (state, action) => {
			if (!action.payload) {
				state.generalLoader = state.generalLoader - 1;
			} else {
				state.loader[action.payload] = (state.loader[action.payload] || 0) - 1;
			}
		})
		.addCase(commonInitApp.fulfilled, (state) => {
			state.isInit = true;
		})
		.addCase(commonGetProvince.fulfilled, (state, action) => {
			let provinceMapped: Provincia[] | undefined = action?.payload?.map((p) => ({
				provincia: p.provincia,
				siglaProvincia: p.siglaProvincia,
				key: p.siglaProvincia,
				value: p.provincia,
			}));
			provinceMapped?.unshift({
				provincia: "",
				siglaProvincia: "",
				key: "",
				value: "",
			});
			state.province = provinceMapped;
		})
		.addCase(commonGetComuni.fulfilled, (state, action) => {
			let provincia = action.meta.arg;
			if (action.payload) {
				let comuniMapped: Comune[] | undefined = action?.payload?.map((c) => ({
					comune: c?.comune,
					key: c?.comune?.toUpperCase(),
					value: c?.comune,
				}));
				comuniMapped?.unshift({
					comune: "",
					key: "",
					value: "",
				});

				state.comuni = {
					...state.comuni,
					[provincia]: comuniMapped,
				};
			}
		})
		.addMatcher(
			(action) => action.type.endsWith("/pending"),
			(state, action) => {
				if (!whitelistLoader.includes(action.type)) {
					state.generalLoader = state.generalLoader + 1;
				}
			}
		)
		.addMatcher(
			(action) => action.type.endsWith("/fulfilled") || action.type.endsWith("/rejected"),
			(state, action) => {
				if (!whitelistLoader.includes(action.type)) {
					state.generalLoader = state.generalLoader - 1;
				}
			}
		);
});
